import React, { useEffect, useState } from "react";
import { PageHero } from "@/components/Section";
import { ArticleCard } from "@/components/ArticleCard";
import { SEO } from "@/components/SEO";
import api from "@/lib/api";
import { CATEGORY_LABELS } from "@/lib/constants";
import { Loader2 } from "lucide-react";

const FILTERS = [
  { key: "", label: "Tout" },
  { key: "actualite", label: "Actualités" },
  { key: "communique", label: "Communiqués" },
  { key: "action", label: "Actions terrain" },
];

export default function Actualites() {
  const [articles, setArticles] = useState([]);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/articles", { params: filter ? { category: filter } : {} })
      .then(({ data }) => setArticles(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <div data-testid="actualites-page">
      <SEO title="Actualités" description="Suivez les actualités, communiqués et actions de terrain du mouvement DEFAR - Les Bâtisseurs partout au Sénégal et dans la diaspora." />
      <PageHero
        overline="Communication"
        title="Actualités & communiqués"
        subtitle="Suivez l'actualité du mouvement, nos communiqués officiels et nos actions sur le terrain."
      />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="flex flex-wrap gap-2 mb-10">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              data-testid={`filter-${f.key || "all"}`}
              onClick={() => setFilter(f.key)}
              className={`px-5 py-2.5 text-sm font-semibold transition-colors ${
                filter === f.key
                  ? "bg-brand-blue text-white"
                  : "bg-brand-surface text-slate-700 hover:bg-brand-surfacealt"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <Loader2 className="animate-spin text-brand-blue" size={32} />
          </div>
        ) : articles.length === 0 ? (
          <p className="text-center text-slate-500 py-20">Aucune publication pour le moment.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((a, i) => (
              <ArticleCard key={a.id} article={a} testid={`article-${i}`} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
